import '../../App.css';
import React, { Component, Container } from 'react';
import { Image, Navbar, Nav, NavItem, NavDropdown } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import YoutubeBackground from 'react-youtube-background';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import NavBarTop from "./navbar";
import Footer from "./footer";


// Video list data - replace with your actual videos
const videoList = [
  { id: "-6s755wkXcA", title: "Greta Barberi e Alessandro Canzani - Claude Debussy Arabesque No.1" },
  { id: "Q2XtNyzhYAA", title: "Benjamin Lim - Chopin Scherzo No. 2" },
  { id: "1Fy1ZPCoojM", title: "Thalia Winata -  F. Liszt, Liebestraum No. 3" },
  { id: "yziJTnrSwyg", title: "Wanqin He - Carl Reinecke Ballade Op.288 for flute and piano" },
  { id: "Lb1fKnxoz7U", title: "Lanang Angin Semilir - Minute Waltz F Chopin Op. 64 No.1" },
  { id: "GJe5CsMj_Ck", title: "Ching Chiao CHANG - Chopin Tarantella, Op. 43" },
  { id: "lbVX9tfI49M", title: "Heidi Fang - ALBERT ZABEL MARGUERITE AU ROUET Op.19" },
];

class WinnerShowcase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentVideoId: videoList[0].id,
      autoplay: 0,
    };

    this.setval = this.setval.bind(this);
    this.handleVideoSelect = this.handleVideoSelect.bind(this);
  }

  componentDidMount() {
    document.title = "International Young Artist Open Competition";
    var link1 = document.getElementById('favicon');
    var link2 = document.getElementById('touchicon');
    link1.href = "/assets/iyao_logo.png";
    link2.href = "/assets/iyao_logo.png";
    this.props.setval({ comp: "iyao" });
  }

  setval(obj) {
    this.setState(obj);
  }

  handleVideoSelect(videoId) {
    this.setState({
      currentVideoId: videoId,
      autoplay: 1,
    });
  }

  render() {
    const { currentVideoId, autoplay } = this.state;

    return (
      <div>
        {/* <img src="/assets/term.png" width="100%" style={{ borderRadius: "0px" }} /> */}

        <div style={{
          display: "flex",
          flexDirection: "column",
          paddingLeft: "10%",
          paddingRight: "10%",
          paddingTop: "4%",
          paddingBottom: "2%",
          textAlign: "left",
          fontFamily: "Courgette"
        }}>
          <h1 style={{ textAlign: "center", marginBottom: "2%", fontSize: "2.5em" }}>
            <em>Winner Showcase</em>
          </h1>

          <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
            {/* Left side - Main YouTube Player */}
            <div style={{ flex: "2", minWidth: "300px" }}>
              <div style={{
                position: "relative",
                paddingBottom: "56.25%",
                height: 0,
                overflow: "hidden",
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.2)"
              }}>
                <iframe
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    border: "none"
                  }}
                  src={`https://www.youtube.com/embed/${currentVideoId}?autoplay=${autoplay}&rel=0`}
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>

            {/* Right side - Scrollable Video List */}
            <div style={{
              flex: "1",
              minWidth: "250px",
              maxHeight: "500px",
              overflowY: "auto",
              border: "1px solid #ddd",
              borderRadius: "12px",
              padding: "10px",
              background: "#f9f9f9"
            }}>
              <h5 style={{ marginBottom: "12px", textAlign: "center", color:"black"}}>Performances</h5>
              {videoList.map((video) => {
  const isActive = currentVideoId === video.id;
  return (
    <div
      key={video.id}
      onClick={() => this.handleVideoSelect(video.id)}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "8px",
        marginBottom: "8px",
        borderRadius: "8px",
        cursor: "pointer",
        background: isActive ? "#ff9800" : "#ffffff",
        color: isActive ? "#ffffff" : "#222222",
        border: isActive ? "2px solid #e68900" : "1px solid #ddd",
        boxShadow: isActive
          ? "0 2px 8px rgba(255, 152, 0, 0.4)"
          : "0 1px 3px rgba(0, 0, 0, 0.08)",
        transition: "all 0.2s ease",
        transform: isActive ? "scale(1.02)" : "scale(1)",
      }}
    >
      <img
        src={`https://img.youtube.com/vi/${video.id}/default.jpg`}
        alt={video.title}
        style={{
          width: "80px",
          height: "60px",
          objectFit: "cover",
          borderRadius: "6px",
          flexShrink: 0,
        }}
      />
      <span
        style={{
          fontSize: "0.95em",
          fontWeight: isActive ? "600" : "400",
          lineHeight: "1.3",
        }}
      >
        {video.title}
      </span>
    </div>
  );
})}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default WinnerShowcase;